<template>
  <div class="contact-form-container fontStix">
    <h1 class="thq-heading-1">{{ $t("contact01") }}</h1>
    <p class="form-subtitle">{{ $t("contact02") }}</p>

    <form @submit.prevent="handleSubmit" class="contact-form">
      <input v-model="form.firstName" type="text" :placeholder="$t('firstname')" class="form-input" required/>
      <input v-model="form.lastName" type="text" :placeholder="$t('name')" class="form-input" required/>
      <input v-model="form.address" type="text" :placeholder="$t('address')" class="form-input" required/>
      <input v-model="form.city" type="text" :placeholder="$t('city')" class="form-input" required/>
      <input v-model="form.email" type="email" :placeholder="$t('email')" class="form-input" required/>
      <input v-model="form.phone" type="text" :placeholder="$t('phone')" class="form-input" required/>
      <input v-model="form.company" type="text" :placeholder="$t('company')" class="form-input" required/>
      <textarea v-model="form.message" rows="5" :placeholder="$t('question')" class="form-textarea" required></textarea>

      <div class="form-checkbox-wrapper">
        <input v-model="form.agree" type="checkbox" id="agree" />
        <label for="agree">{{ $t("contact03") }}<a href="/privacy" target="_blank">{{ $t("contact05") }}</a>.</label>
      </div>

      <button type="submit" class="thq-button-filled">{{ $t("contact04") }}</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Contact',
  data() {
    return {
      //baseURL: "http://localhost:80/MyVlecadOld/",
      baseURL: "https://my.vlecad.be/",
      form: {
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        email: '',
        phone: '',
        company: '',
        message: '',
        agree: false,
      }
    }
  },
  methods: {
    handleSubmit() {
      console.log("handleSubmit called");
      if (!this.form.agree) {
        alert('Je moet akkoord gaan met de verwerking van je gegevens.');
        return;
      }

      // Verzenden via bijvoorbeeld fetch of axios
      axios.post(this.baseURL+'api/mail/sendMailAutofitSoftware.php', this.form)
      .then(res => {
        console.log(JSON.stringify(res.data));
      })
      .catch(err => {
        console.log("error sendMailAutofitSoftware: " + err);
      });

      console.log('Formulier verzonden:', this.form);
      alert('Bedankt! We nemen zo snel mogelijk contact met je op.');

      return false; // Zorgt ervoor dat de pagina niet opnieuw wordt geladen
    }
  }
}
</script>

<style scoped>
.thq-heading-1 {
    font-size: 32px;
    font-family: STIX Two Text;
    font-weight: 700;
    line-height: 1.5;
}

.fontStix {
  font-family: STIX Two Text;
}

.contact-form-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
}

.form-title {
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  color: #1e73be; /* blauw */
  margin-bottom: 1rem;
}

.form-subtitle {
  text-align: center;
  margin-bottom: 2rem;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

.form-textarea {
  resize: vertical;
}

.form-checkbox-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.form-checkbox-wrapper a {
  color: #1e73be;
  text-decoration: underline;
}

.form-button {
  background-color: #e25e20;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  align-self: start;
}

.form-button:hover {
  background-color: #c44d17;
}
</style>
